const sanitizeAuthorizationHeaderFromError = (error) => {
    const headers = error?.config?.headers;
    if (!headers) {
        return error;
    }
    if (typeof headers.delete === 'function') {
        headers.delete('authorization');
        headers.delete('Authorization');
    }
    else {
        delete headers.authorization;
        delete headers.Authorization;
    }
    return error;
};
export { sanitizeAuthorizationHeaderFromError };
//# sourceMappingURL=interceptors.js.map